import './styles/filter-chips.css';

export default function FilterChips({ label, options, value, onChange }) {
    return (
        <div className="filter-chips" role="group" aria-label={label}>
            {options.map((option) => {
                const isActive = option.value === value;
                return (
                    <button
                        key={option.value || 'all'}
                        type="button"
                        className={`filter-chips__chip${isActive ? ' filter-chips__chip--active' : ''}`}
                        aria-pressed={isActive}
                        onClick={() => onChange(option.value)}
                    >
                        {option.label}
                        {Number.isFinite(option.count) && <span className="filter-chips__count">{option.count}</span>}
                    </button>
                );
            })}
        </div>
    );
}
